module.exports = __webpack_public_path__ + "assets/images/tfg_g.2244bbb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/tfg_g.png
// module id = 768
// module chunks = 1